import axios from 'axios';
import UserAuthKey from '../../../../components/Common/UserAuthKey';
import { setNonSaleApprovalList } from '../../../../Redux/services/serviceSlice';
import { setUserData } from '../../../../Redux/user/userSlice';

export const fetchNonSaleApprovalList = async ({ params, dispatch }) => {
  const apiUrl = process.env.REACT_APP_OMS_API;
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/service-order/non-sale-approval-list`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);
    dispatch(setNonSaleApprovalList(response?.data));
    return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    }
  }
};

export const updateNonSaleApprovalStatus = async ({
  id,
  status,
  approvedById,
  approvedByName,
  dispatch,
}) => {
  const apiUrl = process.env.REACT_APP_OMS_API;
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/service-order/update-non-sale-approval-status`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      id,
      status,
      approved_by_id: approvedById,
      approved_by_name: approvedByName,
    },
  };
  try {
    const response = await axios(config);
    return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
      throw error;
    }
  }
};
